import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import API, { resolvePhoto, formatAuthorName } from '../utils/api';
import toast from 'react-hot-toast';
import { Bookmark, BookmarkX } from 'lucide-react';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';

function fmt(d) { try { return format(new Date(d), 'd MMM yyyy', { locale: id }); } catch { return ''; } }

export default function BookmarksPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    API.get('/articles/my-bookmarks')
      .then(r => { setArticles(r.data.articles || []); setLoading(false); })
      .catch(() => { toast.error('Gagal memuat bookmark'); setLoading(false); });
  };
  useEffect(() => { load(); }, []);

  const removeBookmark = async (e, articleId) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await API.post(`/articles/${articleId}/bookmark`);
      setArticles(prev => prev.filter(a => a._id !== articleId));
      toast.success('Dihapus dari bookmark');
    } catch { toast.error('Gagal menghapus'); }
  };

  return (
    <DashboardLayout title="Bookmark Saya" subtitle="Artikel yang Anda simpan untuk dibaca nanti">
      {loading ? (
        <div className="ki-card">{[...Array(4)].map((_, i) => <div key={i} className="shimmer" style={{ height: 80, borderRadius: 8, marginBottom: 10 }} />)}</div>
      ) : articles.length === 0 ? (
        <div className="ki-card" style={{ textAlign: 'center', padding: '60px 24px' }}>
          <Bookmark size={40} style={{ color: 'var(--ki-text-faint)', margin: '0 auto 12px', display: 'block' }} />
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Belum ada bookmark</div>
          <p style={{ color: 'var(--ki-text-muted)', marginBottom: 20, fontSize: 14 }}>
            Simpan artikel dengan menekan ikon bookmark saat membaca.
          </p>
          <Link to="/" className="btn btn-primary">Jelajahi Artikel</Link>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {articles.map(a => (
            <Link key={a._id} to={`/berita/${a.slug || a._id}`} className="ki-card"
              style={{ display: 'flex', gap: 16, padding: 14, textDecoration: 'none', alignItems: 'center' }}>
              {(a.photos?.[a.featuredPhoto || 0]?.url) ? (
                <img src={resolvePhoto(a.photos[a.featuredPhoto || 0].url)} alt="" style={{ width: 110, height: 72, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
              ) : (
                <div style={{ width: 110, height: 72, borderRadius: 8, background: 'var(--in-bg-3)', flexShrink: 0 }} />
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                {a.category?.name && (
                  <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.6, textTransform: 'uppercase', color: a.category.color || 'var(--in-blue)', marginBottom: 4 }}>{a.category.name}</div>
                )}
                <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--in-text)', lineHeight: 1.35, marginBottom: 4 }}>{a.title}</div>
                <div style={{ fontSize: 12, color: 'var(--ki-text-faint)', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {a.assignedEditor?.name && <span>{formatAuthorName(a.assignedEditor.name)}</span>}
                  {a.publishedAt && <span>{fmt(a.publishedAt)}</span>}
                  {a.readingTime && <span>{a.readingTime} MIN BACA</span>}
                </div>
              </div>
              <button onClick={(e) => removeBookmark(e, a._id)} className="btn btn-icon btn-ghost" title="Hapus bookmark" style={{ flexShrink: 0, color: '#DC2626' }}>
                <BookmarkX size={16} />
              </button>
            </Link>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
